import { isDefined } from "@clipboard-health/util-ts";
import type { TuFunction } from "@src/appV2/i18n/types";
import { z } from "zod";
import { fallbackTu } from "@src/appV2/i18n/fallbackTu";

const destinationSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
});

export function getParametersFormSchema(tu: TuFunction = fallbackTu) {
  return z
    .object({
      destination: destinationSchema.nullable().refine((value) => value !== null, {
        message: tu("Destination workplace is required"),
      }),
      effectiveStarting: z.date({ required_error: tu("Effective starting date is required") }),
      effectiveEnding: z.date().nullable(),
    })
    .refine(
      (data) =>
        !isDefined(data.effectiveEnding) ||
        data.effectiveEnding.getTime() >= data.effectiveStarting.getTime(),
      {
        path: ["effectiveEnding"],
        message: tu("Effective ending must be on or after effective starting"),
      }
    );
}

export type ShiftMigrationParametersFormValues = z.input<
  ReturnType<typeof getParametersFormSchema>
>;

export interface ShiftMigrationParametersSubmitValues {
  destination: { id: string; name: string };
  effectiveStarting: Date;
  effectiveEnding?: Date;
}
